// **************************************************************************************

var electricGalleryLightboxZIndex = 20;
var electricGalleryLightboxDelay = 500;
var electricGalleryCurrentImage;

// **************************************************************************************

// Main event setup.
jQuery( document ).ready( electricGalleryReady );

// **************************************************************************************

// Main setup.
function electricGalleryReady() {

	electricGalleryInjectLightbox();
	jQuery( '.wp-block-gallery img' ).on( 'click', function () { electricGalleryShowImage( this ) } );
	jQuery( '.gallery-lightbox-close-button' ).on( 'click', electricGalleryHide );
	jQuery( '.gallery-lightbox-prev-button' ).on( 'click', electricGalleryPrev );
	jQuery( '.gallery-lightbox-next-button' ).on( 'click', electricGalleryNext );
	jQuery( '*:not(.blog-tag-carousel-content) > figure > a:not(.latest-post) > img' ).on( 'click', function () { electricGalleryShowPhoto( event ) } );
}

// **************************************************************************************

// Inject the gallery lightbox.
function electricGalleryInjectLightbox() {

	var lightboxHTML = '<div class="gallery-lightbox">';
	lightboxHTML += '<div class="gallery-lightbox-close-button"></div>';
	lightboxHTML += '<div class="gallery-lightbox-prev-button"></div>';
	lightboxHTML += '<div class="gallery-lightbox-image"></div>';
	lightboxHTML += '<div class="gallery-lightbox-loader"></div>';
	lightboxHTML += '<div class="gallery-lightbox-next-button"></div>';
	lightboxHTML += '<div class="gallery-lightbox-caption"><span></span></div>';
	lightboxHTML += '</div>';

	jQuery( 'body' ).append( lightboxHTML );

}

// **************************************************************************************

// Show the specified image in the lightbox.
function electricGalleryShowImage( $image ) {

	electricGalleryCurrentImage = jQuery( $image );

	jQuery( '.gallery-lightbox-image' ).css( 'opacity', 0 );
	jQuery( '.gallery-lightbox-caption' ).css( 'opacity', 0 );
	jQuery( '.gallery-lightbox-loader' ).css( 'opacity', 1 );

	jQuery( '.gallery-lightbox' ).css( 'zIndex', electricGalleryLightboxZIndex );
	jQuery( '.gallery-lightbox' ).css( 'opacity', 1 );

	var url = electricGalleryCurrentImage.attr( 'data-full-url' );
	if ( undefined == url ) url = electricGalleryCurrentImage.attr( 'src' );

	var caption = '';
	if ( 0 < electricGalleryCurrentImage.next().length ) {
		caption = electricGalleryCurrentImage.next()[0].innerHTML;
	}

	var loader = new Image();

	jQuery( loader ).on( 'load', function () {

		jQuery( '.gallery-lightbox-image' ).css( 'backgroundImage', 'url(' + url + ')' );

		window.setTimeout( function () {

			jQuery( '.gallery-lightbox-loader' ).css( 'opacity', 0 );
			jQuery( '.gallery-lightbox-image' ).css( 'opacity', 1 );

			var images = electricGalleryCurrentImage.parent().parent().prev().find( 'img' );
			if ( images.length == 1 ) {
				jQuery( '.gallery-lightbox-prev-button' ).css( 'opacity', 1 );
			} else {
				jQuery( '.gallery-lightbox-prev-button' ).css( 'opacity', 0 );
			}

			var images = electricGalleryCurrentImage.parent().parent().next().find( 'img' );
			if ( images.length == 1 ) {
				jQuery( '.gallery-lightbox-next-button' ).css( 'opacity', 1 );
			} else {
				jQuery( '.gallery-lightbox-next-button' ).css( 'opacity', 0 );
			}

			jQuery( '.gallery-lightbox-caption' ).css( 'opacity', 1 );
			jQuery( '.gallery-lightbox-caption span' ).html( caption );

		}, electricGalleryLightboxDelay );

	} );

	window.setTimeout( function () {
		loader.src = url;
	}, 100 );

}

// **************************************************************************************

//Show the photo.
function electricGalleryShowPhoto( event ) {

	event.preventDefault();
	var target = event.target;
	electricGalleryShowImage( target );

}

// **************************************************************************************

// Show the previous image in the lightbox.
function electricGalleryPrev() {

	var images = electricGalleryCurrentImage.parent().parent().prev().find( 'img' );
	if ( images.length == 1 ) {

		var image = images[0];
		electricGalleryShowImage( image );

	}

}

// **************************************************************************************

// Show the next image in the lightbox.
function electricGalleryNext() {

	var images = electricGalleryCurrentImage.parent().parent().next().find( 'img' );
	if ( images.length == 1 ) {

		var image = images[0];
		electricGalleryShowImage( image );

	}

}

// **************************************************************************************

// Hide the gallery lightbox.
function electricGalleryHide() {

	jQuery( '.gallery-lightbox' ).css( 'zIndex', -1 );
	jQuery( '.gallery-lightbox' ).css( 'opacity', 0 );

}

// **************************************************************************************
